// Shared money/month helpers for the cost & income cards.
import { formatGBP } from "@/lib/brand";

export const SHORT = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
export const LONG = ["January","February","March","April","May","June","July","August","September","October","November","December"];

export function monthNames(startIso, long = false) {
  const [y, m] = (startIso || "").split("-").map(Number);
  return Array.from({ length: 12 }, (_, i) => {
    const t = (m || 1) - 1 + i;
    return long ? `${LONG[t % 12]} ${(y || 0) + Math.floor(t / 12)}` : SHORT[t % 12];
  });
}

export const FREQ_LABELS = {
  monthly: "Every month",
  quarterly: "Quarterly",
  bi_annual: "Twice a year",
  annual: "Once a year",
  custom: "Custom months & amounts",
};

const amt = (c) => Number(c.amount) || 0;
export const customAmounts = (c) => (c.months_active || []).map((k) => {
  const v = c.monthly_amounts?.[k];
  return v === null || v === undefined ? amt(c) : Number(v) || 0;
});

export function annualTotal(c) {
  switch (c.frequency || "monthly") {
    case "quarterly": return amt(c) * 4;
    case "bi_annual": return amt(c) * 2;
    case "annual": return amt(c);
    case "custom": return customAmounts(c).reduce((a, b) => a + b, 0);
    default: return amt(c) * 12;
  }
}

export function contingencyAmount(costs, c) {
  if (c.contingency_mode !== "pct") return amt(c);
  const base = costs.filter((x) => !x.is_contingency && x.name).reduce((s, x) => s + annualTotal(x), 0) / 12;
  return Math.round((base * (Number(c.contingency_pct) || 0)) / 100);
}

export function regularHeader(c, i, startIso, costs) {
  if (c.is_contingency) {
    const value = contingencyAmount(costs, c);
    return c.contingency_mode === "pct"
      ? `Contingency · ${Number(c.contingency_pct) || 0}% of regular costs · ${formatGBP(value)}/month`
      : `Contingency · Every month · ${formatGBP(value)}`;
  }
  const name = c.name || `Regular cost ${i + 1}`;
  const f = c.frequency || "monthly";
  const months = monthNames(startIso, true);
  if (f === "custom") {
    const vals = customAmounts(c);
    const same = vals.every((v) => v === vals[0]);
    const money = same ? `${formatGBP(vals[0] || 0)} each` : `${formatGBP(vals.reduce((a, b) => a + b, 0))} total`;
    return `${name} · Custom · ${vals.length} month${vals.length === 1 ? "" : "s"} · ${money}`;
  }
  if (f === "monthly") return `${name} · Every month · ${formatGBP(amt(c))}`;
  return `${name} · ${FREQ_LABELS[f]} · ${f === "annual" ? "" : "from "}${months[Number(c.anchor_month_index) || 0]} · ${formatGBP(amt(c))}`;
}

export const costComplete = (c) => c.is_contingency || (!!(c.name || "").trim() && amt(c) > 0);
